'use strict';

import template from './mx-dialog-container.html';

export const MxDialogContainerComponent = {
	bindings: {
		contentWidgetId: '=?',
		objectId: '=?',
		view: '=?',
		onValidationChanged: '&',
		dialogType: '=?',
		previewObject: '<?',
		presetFields: '=?',
		displayStrings: '=?',
		widget: '=?',
		errors: '=?',
		showWarning: '=?',
		warningMessage: '=?',
		warningMessageButtonLabel: '@',
		warningMessageButtonHandler: '&',
		entity: '=?',
		entityName: '=?',
		entityData: '=?',
		watchEntityData: '=?',
		hideMessagePanel: '=?',
		extraContext: '=?',
		isSingleView: '<?',
		views: '=?',
		entityDataModel: '=?',
		useExternalTabManager: '<',
	},
	require: {
		parentMxWizard: '^?mxWizard',
		mxForm: '?^mxForm',
	},
	controller: MxDialogContainerCtrl,
	controllerAs: 'vm',
	template: template,
};

MxDialogContainerCtrl.$inject = [
	'mx.SolutionBuilderAgent.DataModelService',
	'mx.SolutionBuilderAgent.ContentWidgetService',
	'mx.shell.ContextService',
	'mx.shell.SidePanelService',
	'mx.SolutionBuilderAgent.SchemaService',
	'mx.SolutionBuilderAgent.ExternalServiceManager',
	'mx.shell.KeyboardNavigationService',
	'mx.internationalization',
	'mx.shell.EventService',
	'mx.SolutionBuilderAgent.mxLocalizationModeHelper',
	'$scope',
	'$timeout',
	'$element',
	'$q',
	'mx.SolutionBuilderAgent.EntityService',
	'mx.SolutionBuilderAgent.DialogOpenerService',
	'mx.SolutionBuilderAgent.WidgetManager',
	'mx.shell.SidePanelActionsService',
];

export function MxDialogContainerCtrl(
	dataModelService,
	contentWidgetService,
	contextService,
	sidePanelService,
	schemaService,
	externalServiceManager,
	keyboardNavigationService,
	i18n,
	eventService,
	localizationModeHelper,
	$scope,
	$timeout,
	$element,
	$q,
	entityService,
	dialogOpenerService,
	widgetManager,
	sidePanelActionsService
) {
	var vm = this;
	var entityWatcher;
	var freeDataSourceDefer = $q.defer();

	var _externalWizardLoadingValidatingFn = function () {
		return typeof vm === 'undefined' || vm.loaded;
	};
	vm.$onInit = function () {
		vm.context = (vm.view || {}).context || vm.extraContext || {};
		vm.entity = vm.entity || {};
		vm.loaded = false;
		if (vm.parentMxWizard) {
			vm.parentMxWizard.__externalValidators.push(_externalWizardLoadingValidatingFn);
		}
		vm.errors = vm.errors || [];
		vm.visitedTabs = [];
		vm.availableViews = vm.views ? (Array.isArray(vm.views) ? vm.views : [vm.views]) : [];
		vm.viewFilter = function (view) {
			return view.visible !== false;
		};
		registerHotkeys();

		eventService.subscribeTo(
			mx.shell.EventCodes.RefreshCurrentView,
			function (e, data) {
				if (data.view.id === vm.view.id) {
					vm.loaded = false;
					if (typeof data.newEntityType !== 'undefined' || typeof data.newDialogType !== 'undefined') {
						if (typeof data.newDialogType !== 'undefined') {
							vm.view.dialogType = data.newDialogType;
							vm.dialogType = data.newDialogType;
						}

						if (typeof data.newEntityType !== 'undefined') {
							vm.entityName = data.newEntityType;
							vm.contentWidgetId = null;
							reInitWidget({ InternalName: vm.entityName });
						} else {
							vm.entityName = vm.view.type;
							contentWidgetService.getViews(vm.entityName).then(function (views) {
								var firstView = findSuitableView(views);
								var newContentWidgetId = vm.contentWidgetId || firstView.Id;
								if (newContentWidgetId !== vm.contentWidgetId) {
									vm.contentWidgetId = newContentWidgetId;
									reInitWidget({ InternalName: vm.entityName });
								} else {
									reloadDialogData();
								}
							});
						}
					} else {
						reloadDialogData();
					}
				}
			},
			$scope
		);

		eventService.subscribeTo(
			mx.SolutionBuilderAgent.Events.ObjectDataChanged,
			function (e, params) {
				params = params || {};
				if (!params.hideDetails && vm.objectId && params.affectedObjectIds && params.affectedObjectIds.indexOf(vm.objectId) !== -1 && vm.view !== params.view) {
					reloadDialogData();
				}
			},
			$scope
		);

		$scope.$watch('vm.view.selectedTab', function (newValue) {
			if (vm.visitedTabs.indexOf(newValue) === -1) {
				vm.visitedTabs.push(newValue);
			}
		});
		setDialogType().then(initWidget).catch(handleDialogError);
	};

	vm.$onDestroy = function () {
		if (vm.parentMxWizard) {
			var idx = vm.parentMxWizard.__externalValidators.indexOf(_externalWizardLoadingValidatingFn);
			if (idx > -1) {
				vm.parentMxWizard.__externalValidators.splice(idx, 1);
			}
		}
		freeDataSourceDefer.resolve(true);
		localizationModeHelper.destroyCustomEditorInstances();
	};

	// Localization mode
	var _openLocalozationDialog;
	eventService.subscribeTo(
		mx.shell.EventCodes.SwitchLocalizationMode,
		function (_, incommingParams) {
			if (vm.view !== incommingParams.view) {
				return;
			}
			if (incommingParams.view.__localizationModeEnabled) {
				(vm.entity && (vm.entity['Sys-IsNew'] || vm.entity.__localizationDataLoaded)
					? $q.when(vm.entity)
					: contentWidgetService.getDialogData(vm.widget.id, vm.objectId, vm.context._archived, true, makeContextParams()).then(function (res) {
							return res.entity;
					  })
				).then(function (entity) {
					vm.entity.__localizationDataLoaded = true;

					localizationModeHelper.enableMode($element);

					var localizableModels = [];
					var _localizableModelsCollector = function (fieldName) {
						localizableModels.push('vm.dataModel.' + entity['Sys-Entity'] + '.' + key.slice(0, -3) + '.' + fieldName);
					};
					for (var key in entity) {
						// If Key ends with "-CI"
						if (entity.hasOwnProperty(key) && key.lastIndexOf('-CI') + 3 === key.length && entity[key].fields) {
							vm.entity[key] = entity[key];
							// if it has 'Rows' key - it's for `ClassColumns` but we need just for `ClassBases`
							if (!entity[key].Rows) {
								entity[key].fields.forEach(_localizableModelsCollector);
							}
						}
					}

					localizationModeHelper.applyStylesForControls($element, localizableModels);

					_openLocalozationDialog = function (event) {
						_handleLocalizationDialogAppearance(event, _prepareLocalizedResult, localizableModels, entity, vm.entity);
					};

					// Handle events
					$(localizationModeHelper.dialogSelector)[0].addEventListener('click', _openLocalozationDialog, true);
				});
			} else {
				$(localizationModeHelper.dialogSelector)[0].removeEventListener('click', _openLocalozationDialog, true);
				localizationModeHelper.disableMode($element);
			}
		},
		$scope
	);

	return vm;

	function setDialogType() {
		var isNewObject = !vm.objectId || vm.objectId === 'new';
		var typeDependsFromViews = !isNewObject && vm.entityName && vm.objectId && (vm.previewObject || vm.context._previewMode);

		return (typeDependsFromViews ? widgetManager.getPreviews(vm.entityName) : $q.when(null)).then(function (previews) {
			if (previews && previews.length) {
				vm.objectDetailsMode = true;
				vm.dialogType = mx.SolutionBuilderAgent.ContentWidgetDialogAction.Preview;
			} else {
				vm.objectDetailsMode = vm.dialogType === mx.SolutionBuilderAgent.ContentWidgetDialogAction.Preview;
				if (isNewObject) {
					vm.dialogType = mx.SolutionBuilderAgent.ContentWidgetDialogAction.New;
				} else {
					vm.dialogType = vm.dialogType || mx.SolutionBuilderAgent.ContentWidgetDialogAction.Edit;
				}
			}
		});
	}

	function initWidget() {
		if (vm.entityName) {
			var entityNameIsId = /^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(vm.entityName);
			return schemaService.getType(vm.entityName, entityNameIsId).then(reInitWidget);
		} else {
			return loadWidget();
		}
	}

	function reInitWidget(entityInfo) {
		changeEntityName(entityInfo ? entityInfo.InternalName : null);

		if (vm.watchEntityData) {
			$scope.$watch(
				'vm.entityDataModel',
				function (newData) {
					if (newData) {
						vm.entityData = JSON.stringify(vm.entityName ? newData[vm.entityName] : newData);
					}
				},
				true
			);
		}
		vm.viewParameters = { dataModel: vm.entityDataModel };

		return widgetManager.getSortedViews(vm.entityName).then(function (views) {
			var firstView;
			if (!vm.contentWidgetId) {
				firstView = findSuitableView(views);
				if (firstView) {
					vm.contentWidgetId = firstView.Id;
				} else {
					//vm.showNoFormMessage  = true;
					throw new Error(i18n.get('solutionBuilderAgent.components.mx-dialog-container.noDialogFound'));
				}
			}

			if (vm.view && firstView) {
				vm.view.headerTitle = firstView.EntityDisplayName;
				vm.view.headerIcon = firstView.EntityIcon;
				vm.view.headerColor = firstView.EntityColor;
				vm.view.purpose = firstView.Purpose;

				if (vm.view.locals) {
					vm.view.locals.widgetId = vm.contentWidgetId;
					vm.view.locals.entityDisplayName = firstView.EntityDisplayName;
				}
			}

			return loadWidget();
		});
	}

	function findSuitableView(views) {
		return widgetManager.filterViews(views, vm.dialogType)[0];
	}

	function changeEntityName(newValue) {
		if (typeof entityWatcher === 'function') {
			entityWatcher();
		}
		vm.entityName = newValue;
		$scope.$evalAsync(function () {
			entityWatcher = $scope.$watch('vm.entityName', onDialogEssentialsChanged);
		});
	}

	function onDialogEssentialsChanged(newValue, oldValue) {
		if (newValue !== oldValue) {
			vm.contentWidgetId = null;
			// vm.objectId = 'new';
			initWidget();
		}
	}

	function registerHotkeys() {
		keyboardNavigationService.registerKey([
			{
				key: 'alt+shift+right',
				hint: '⇧+→',
				description: i18n.get('solutionBuilderAgent.components.mx-dialog-container.next'),
				callback: function () {
					$timeout(function () {
						$('.mx-dialog-content--inner > md-tabs md-tab-item.md-active:visible:first').next().click();
					});
				},
			},
			{
				key: 'alt+shift+left',
				hint: '⇧+←',
				description: i18n.get('solutionBuilderAgent.components.mx-dialog-container.previous'),
				callback: function () {
					$timeout(function () {
						$('.mx-dialog-content--inner > md-tabs md-tab-item.md-active:visible:first').prev().click();
					});
				},
			},
		]);
	}

	function loadWidget() {
		return $q.all([loadData(), loadTemplate()]).then(function (data) {
			const entityData = data[0];
			return onLoadEntity(entityData.entity, vm.widget.extensions, entityData.isService);
		}, handleDialogError);
	}

	async function handleDialogError(e) {
		if (
			e.message?.indexOf(i18n.get('solutionBuilderAgent.components.mx-dialog-container.noDialogFound')) > -1 ||
			e === mx.warnCatchMessage('User has no permissions for necessary application (or application is not found)')
		) {
			contentWidgetService.checkViewUnavailableReasons(vm.entityName, vm.dialogType).then(
				function () {
					vm.showNoDataMessage = true;
					vm.errorMessage = e;
				},
				function (error) {
					vm.showNoDataMessage = true;
					vm.errorMessage = error.message || error;
				}
			);
			return;
		} else if (e?.key === 'Matrix42.Pandora.BizLogic.ContentWidget.ObjectIsDeleted') {
			eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.ObjectDataDeleted, { affectedObjectIds: [vm.objectId] });
		}

		console.error(e.message || e);
		vm.showNoDataMessage = true;
		vm.errorMessage = e.message || e;
		vm.errorTitle = e.title;
	}

	function loadTemplate() {
		return contentWidgetService.getHtml(vm.contentWidgetId, vm.objectId === 'new').then(function (widgetData) {
			if (widgetData && widgetData.Template.Views && widgetData.Entity) {
				var extensions = widgetData.Template.DataModelExtensions ? JSON.parse(widgetData.Template.DataModelExtensions) || {} : {};

				vm.widget = {
					id: widgetData.Id,
					entity: widgetData.Entity,
					extensions: extensions,
					nonVisualTemplate: widgetData.Template.NonVisualTemplate,
					views: widgetData.Template.Views.sort(function (view1, view2) {
						return (view1.Position || 0) - (view2.Position || 0);
					}),
					helpSourceType: widgetData.HelpSourceType || 0,
					helpValue: widgetData.HelpValue || '',
				};

				if (Array.isArray(vm.availableViews) && vm.availableViews.length > 0) {
					var filteredViews = vm.widget.views.filter(function (r, i) {
						// We have to always show 1st view for `Create New Dialog` (not necessary for `Edit Dialog`)
						// because it may contains Mandatory input-fields without which Dialog couldn't be submitted.
						// PBI: #120379
						return vm.availableViews.indexOf(r.Id) >= 0 || (vm.objectId === 'new' && i === 0);
					});
					if (filteredViews.length > 0) {
						vm.widget.views = filteredViews;
					}
				}

				if (!vm.view) {
					vm.view = {
						id: vm.widget.id,
						entity: vm.widget.entity,
					};
				}

				vm.isSingleView = Boolean(vm.isSingleView);
				if (!vm.isSingleView) {
					// take from locals (quickLink) or from parent objectDetails
					vm.isSingleView = Boolean(vm.view.isSingleView || (vm.view.locals && vm.view.locals.isSingleView) || (vm.view.parentView && vm.view.parentView.isSingleView));
					// or if we have only one view (could be [0] or any other view  - from deeplinking)
				}

				vm.view.tabs = vm.widget.views.sort((a, b) => {
					if (a.Position !== b.Position) {
						return a.Position - b.Position;
					} else {
						return a.Key === b.Key ? 0 : a.Key > b.Key ? 1 : -1;
					}
				});

				if (Array.isArray(vm.view.tabs) && vm.view.tabs.length) {
					vm.view.selectedTab = vm.view.tabs[0];

					if (vm.isSingleView || vm.widget.views.length === 1) {
						vm.view.tabs.forEach(function (tab) {
							tab.visible = false;
						});
					}

					vm.view.tabs.forEach((tab) => {
						tab.serviceContextInfo = {
							widgetId: vm.contentWidgetId,
							viewName: tab.Key,
						};
					});
				}

				if (vm.view.correspondingUrl) {
					var extObj = {};
					if (vm.view.hideActions) {
						extObj.ext = 1;
					}
					if (vm.isSingleView) {
						extObj.std = 1;
					}
					if (vm.view.readOnly) {
						extObj.nda = 1;
					}
					if (Object.keys(extObj).length) {
						contentWidgetService.extendCorrespondingUrl(vm.view, extObj);
					}
				}

				vm.view.helpSourceType = vm.widget.helpSourceType;
				vm.view.helpValue = vm.widget.helpValue;
			} else {
				return $q.reject('Data for widget id=' + vm.contentWidgetId + ' was not found');
			}
		});
	}

	function loadData() {
		vm.loaded = false;
		return contentWidgetService.getWidgetInfoById(vm.contentWidgetId).then(function (widgetInfo) {
			if (!widgetInfo) {
				throw new Error(i18n.get('solutionBuilderAgent.components.mx-dialog-container.noDialogFound'));
			}

			var isService = externalServiceManager.isService(widgetInfo.Entity);
			return (isService ? getServiceEntity(widgetInfo.Entity) : getGenericEntity(widgetInfo.Entity)).then(function (entity) {
				entity.IsNew = entity['Sys-IsNew'];

				if (vm.view && i18n.isNotEmpty(entity._displayName)) {
					if (!vm.view.name) {
						vm.view.name = entity._displayName || '';
					}

					vm.view.displayName = vm.view.displayName || '';

					if (entity._displayName && entity._displayName !== vm.view.displayName) {
						vm.view.displayName = entity._displayName;
						eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.ObjectDisplayNameChanged, {
							objectId: vm.objectId,
							entityType: vm.entityName,
							displayName: vm.view.displayName,
						});
					}
				}

				return {
					entity: entity,
					isService: isService,
				};
			});
		});
	}

	function makeContextParams() {
		var context = {};
		if (vm.view && vm.view.startedFromAction) {
			context['mx-action-name'] = vm.view.startedFromAction.name;
		}
		return context;
	}

	function getGenericEntity(entityName) {
		changeEntityName(entityName);
		if (vm.dialogType === mx.SolutionBuilderAgent.ContentWidgetDialogAction.New) {
			return contentWidgetService
				.getNewDialogData(vm.contentWidgetId, vm.view && vm.view.controllerParams, vm.view && vm.view.selectedObjects, makeContextParams())
				.then(function (object) {
					vm.objectId = object.entity._id;
					vm.displayStrings = object.displayStrings;
					return angular.merge(object.entity, vm.entity);
				});
		} else {
			return contentWidgetService.getDialogData(vm.contentWidgetId, vm.objectId, vm.context._archived, false, makeContextParams()).then(function (object) {
				vm.displayStrings = object.displayStrings;
				return object.entity;
			});
		}
	}

	function getServiceEntity(entityName) {
		return externalServiceManager.getEntity(entityName, vm.objectId).then(function (data) {
			changeEntityName(data.entityName); // Name
			return data.object;
		});
	}

	function reloadDialogData() {
		return loadData().then(function (entityData) {
			return onLoadEntity(entityData.entity, vm.widget.extensions, entityData.isService);
		}, handleDialogError);
	}

	function prepareContext(entity) {
		const presetFields = $.extend(true, {}, vm.presetFields || {});
		var presetContext = presetFields.Context || {};
		delete presetFields.Context;
		$.extend(true, entity, presetFields);

		var ctx = {
			WidgetId: vm.widget.id,
			OuterContext: vm.view && vm.view.locals && vm.view.locals.outerContext,
		};
		ctx[mx.SolutionBuilderAgent.DataModelSystemProperty.Shared] = contextService.val('ApplicationSharedContext');

		if (vm.view) {
			if (vm.view.startedFromAction) {
				ctx.ActionName = vm.view.startedFromAction.name;
			}

			var item =
				Array.isArray(vm.view.selectedObjects) && vm.view.selectedObjects.length > 0
					? vm.view.selectedObjects[0]
					: vm.view.context && vm.view.context._id
					? vm.view.context
					: { _id: '', _type: '', _displayName: '' };

			ctx.Object = $.extend(true, item, {
				Id: item._id,
				Type: item._type,
				DisplayName: item._displayName,
			});
		}
		$.extend(true, ctx, presetContext);

		return ctx;
	}

	function onLoadEntity(entity, dataModelExtensions, isService) {
		var context = prepareContext(entity);
		return dataModelService
			.loadDialogDataModel(vm.entityName, entity, context, dataModelExtensions, freeDataSourceDefer.promise, isService)
			.then(function (filledObject) {
				vm.entityDataModel = filledObject;
				vm.entity = vm.entityDataModel[vm.entityName];

				if (vm.mxForm && vm.entity && !vm.entity.IsNew && vm.entity._archived) {
					// To support legacy code it is used form.readOnly.
					// Should be used dialog.readOnly instead of mxFrom.readonly here, and all components should use dialog.readOnly flag (dialogs tree instead of one mxForm)
					vm.mxForm.setExternalReadOnly(true, 'mxDialogContainerIsArchived');
				}

				Object.defineProperty(vm.entity, '$$initialEntity', {
					enumerable: false,
					writable: true,
					value: dataModelService.serializeObject(dataModelService.cleanFromEmptyOptionalDataDefinition(vm.entity)),
				});

				vm.name = vm.entityDataModel[vm.entityName]._name; // Name
				vm.entityDataModel.entityName = dataModelExtensions.entityName;

				if (vm.view) {
					if (i18n.isNotEmpty(vm.name) || !vm.view.name) {
						vm.view.name = vm.name;
					}
					vm.view.context = vm.entityDataModel[vm.entityName];
					if (vm.view.locals && vm.view.locals.selectedObjects && vm.view.locals.selectedObjects.length === 1) {
						vm.view.locals.selectedObjects[0] = vm.view.context;
					}
				}
			})
			.then(function () {
				if (vm.widget.views.length === 1 || vm.isSingleView) {
					vm.singleView = vm.widget.views[0];
					vm.singleViewServiceContextInfo = vm.view.tabs[0]?.serviceContextInfo;
				}

				vm.showNoFormMessage = vm.widget.views.length === 0;
				eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.ViewDataLoaded, vm.view);
				if (Boolean(vm.view.__localizationModeEnabled) === true) {
					$(localizationModeHelper.dialogSelector)[0].removeEventListener('click', _openLocalozationDialog, true);
					localizationModeHelper.disableMode($element);
					eventService.dispatchEvent(mx.shell.EventCodes.SwitchLocalizationMode, { view: vm.view });
				}

				var isManualActionCalculationEnabled = (vm.widget.nonVisualTemplate || '').indexOf('<mx-recalculate-actions') >= 0;
				if (!isManualActionCalculationEnabled) {
					sidePanelActionsService.calculateViewActions(vm.view);
				}

				vm.loaded = true;

				$scope.$applyAsync(function () {
					$element.find('.mx-dialog-content').trigger('focus');
				});
			});
	}

	function _handleLocalizationDialogAppearance(event, dialogSavedCallback, localizableModels, sourceEntity, entityToBeSaved) {
		var controlElm = localizationModeHelper.preventUsualControlHandler(event, localizableModels);
		if (controlElm) {
			var modelInfo = localizationModeHelper.getModelInfoFromElement(controlElm);
			var entityClass = modelInfo.modelPath[3];
			localizationModeHelper
				.openLocalizationDialog(
					controlElm,
					sourceEntity[entityClass][modelInfo.fieldKey],
					sourceEntity[entityClass + '-CI'],
					entityToBeSaved[entityClass][modelInfo.fieldKey]
				)
				.then(function (params) {
					dialogSavedCallback(params.localizedField, entityToBeSaved, modelInfo.fieldKey, entityClass, params.currentLang);
				}, angular.noop);
		}
		return false;
	}

	function _prepareLocalizedResult(localizedField, entityToBeSaved, fieldKey, entityClass, currentLang) {
		entityToBeSaved['Sys-AllCulturesLoaded'] = true;

		var object = entityToBeSaved[entityClass];
		var objectCI = entityToBeSaved[entityClass + '-CI'];

		if (objectCI) {
			localizationModeHelper.applyTranslations(localizedField, fieldKey, objectCI);
		}

		object[fieldKey] = localizationModeHelper.getValueWithFallback(localizedField, currentLang);
	}
}
